<app-page-header title="Adatkezelési tájékoztató"></app-page-header>

<div class="content m-5">
  <p>
    A személyes adatok kezelésével összefüggő tevékenységeinket az új Európai
    Uniós általános adatvédelmi rendeletben (GDPR: General Data Protection
    Regulation) kötelezően előírt és alkalmazandó szabályok tekintetében
    felülvizsgáltuk és elkötelezettek vagyunk aziránt, hogy az abban, valamint a
    hazai hatályos jogszabályokban meghatározott követelményeknek megfelelően
    végezzük.
  </p>
  <p><strong>Az Adatkezelő adatai, elérhetősége:</strong></p>
  <table>
    <tbody>
      <tr>
        <td width="305">
          A weboldal üzemeltetője, a weboldalon vagy
          <p></p>
          <p>e-mailben megadott személyes adatok kezelője</p>
          <p>(a továbbiakban: Adatkezelő):</p>
        </td>
        <td width="299">Dunaszentmiklós Község Önkormányzata</td>
      </tr>
      <tr>
        <td width="305"><strong>Elérhetőségeink: </strong></td>
        <td width="299"></td>
      </tr>
      <tr>
        <td width="305">Cím:</td>
        <td width="299">2897 Dunaszentmiklós, Petőfi u. 52.</td>
      </tr>
      <tr>
        <td width="305">Email cím:</td>
        <td width="299">ph@dunaszentmiklos.hu</td>
      </tr>
      <tr>
        <td width="305">Telefon::</td>
        <td width="299">+36 34 491-819</td>
      </tr>
      <tr>
        <td width="305">Adatvédelmi felelős:</td>
        <td width="299">dr. Dezső Marianna (L Tender-Consulting Kft.)</td>
      </tr>
      <tr>
        <td width="305">Elérhetősége:</td>
        <td width="299">adatkezeles@tata.hu</td>
      </tr>
    </tbody>
  </table>
  <p>&nbsp;</p>
  <p><strong>Az adatkezelés alapelvei: </strong></p>
  <p>
    Elkötelezettek vagyunk a weboldalt felkereső látogatóink és minden érintett
    személyes adatainak védelmében egyaránt, kiemelten fontosnak tartjuk
    információs önrendelkezési jogának tiszteletben tartását.
  </p>
  <p>
    A személyes adatokat bizalmasan kezeljük és megteszünk minden olyan
    biztonsági, technikai és szervezési intézkedést, amely a személyes adatok
    biztonságát garantálja.
  </p>
  <p>
    Amennyiben olyan kérdése merül fel, amely jelen adatkezelési tájékoztatónk
    alapján nem egyértelmű, kérjük, hogy vegye fel a kapcsolatot velünk fenti
    elérhetőségeinken! Törekszünk arra, hogy minél gyorsabban válaszoljunk
    Önnek, viszont amennyiben kérdése megfelelő megválaszolása több időt vesz
    igénybe, akkor legfeljebb 15 napon belül vállaljuk annak megválaszolását.
  </p>
  <p>
    Bármikor kérhet tájékoztatást személyes adatai kezelésével kapcsolatban
    írásban (emailben, illetve postai címünkre megküldött levélben) vagy szóban
    (telefonon). Felhívjuk a figyelmét, hogy telefonon történő megkeresése
    esetén – amennyiben adatkezeléssel kapcsolatos igénye indokolja (pl.:
    adatainak törlését kéri) –, akkor azonosítanunk kell abból a célból, hogy
    jogosult-e a kérésre, mielőtt teljesítjük azt. Ha az azonosítás nem
    lehetséges, akkor kizárólag általános tájékoztatást adhatunk az
    adatkezeléssel kapcsolatban. Emiatt javasoljuk, hogy kérdését vagy igényét
    lehetőleg írásban jelezze.
  </p>
  <p><strong>Alkalmazott jogszabályok </strong></p>
  <p>
    Kötelezettséget vállalunk arra, hogy a személyes adatok kezelését a
    mindenkori hatályos, különösen pedig az alábbiakban felsorolt jogszabályi
    előírásoknak megfelelően végezzük:
  </p>
  <p>
    Az Európai Parlament és a Tanács (EU) 2016/679 rendelete (2016. április 27.)
    a természetes személyeknek a személyes adatok kezelése tekintetében történő
    védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK
    rendelet, hatályon kívül helyezés (általános adatvédelmi rendelet), vagy más
    néven GDPR: General Data Protection Regulation;. 2011. évi CXII. törvény
    (Infotv.) az információs önrendelkezési jogról és információszabadságról.
  </p>
  <p>&nbsp;</p>
  <p><strong>Panaszkezelés és további jogérvényesítési lehetőségek </strong></p>
  <p>
    Mindent tőlünk telhetőt megteszünk, hogy a személyes adatok kezelése a
    jogszabályoknak megfelelően történjék. Amennyiben úgy érzi, hogy nem
    feleltünk meg ennek kérjük, jelezze adatvédelmi tisztviselőnknek
    elérhetőségén.
  </p>
  <p>
    Személyes adatai védelméhez fűződő jogai megsértése esetén jogorvoslati
    lehetőségért – amennyiben az Adatkezelő az Ön jelzése ellenére sem szünteti
    meg jogsértő magatartását – a Nemzeti Adatvédelmi és Információszabadság
    Hatósághoz fordulhat, alábbi elérhetőségein:
  </p>
  <p>
    Hivatalos név: Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)
  </p>
  <p>Postai cím: 1125 Budapest, Szilágyi Erzsébet fasor 22/c.</p>
  <p>Telefonszám: +3613911400</p>
  <p>Email: ugyfelszolgalat@naih.hu</p>
  <p>Weboldal: www.naih.hu</p>
  <p><strong>A weboldalon kezelt adatok </strong></p>
  <p>
    Weboldalunk nyilvános tartalmát bárki – személyes adatai megadása nélkül –
    megtekintheti, az nem kötődik regisztrációhoz vagy bejelentkezéshez.
  </p>
  <p>
    A weboldal meglátogatása, használata során az alábbiakban felsorolt adatokat
    kezeljük a jelen tájékoztatóban megfogalmazott célból és ideig, továbbá az
    adatkezeléshez fűződő jogai érvényesítését a következők szerint biztosítjuk:
  </p>
  <p><strong>Sütik (cookie) kezelése </strong></p>
  <p>Mi a süti?</p>
  <p>
    A süti (cookie) a weboldalunk megnyitása és használata során az Ön által
    erre, az internet elérésére használt készülékén (számítógép, okostelefon)
    elhelyezett szöveges fájl. Ez jellemzően a webszerver és az Ön készüléke
    közötti kapcsolatra vagy a weboldal működésére vonatkozó információkat
    tartalmaz (például úgynevezett munkamenet vagy session azonosítót, amely egy
    betűkből, számokból és egyéb írásjelekből álló egyedi karaktersorozat. A
    weboldal Ön által történő megnyitásának, felkeresésének időpontját, stb.), s
    amelynek tartalmát alkalmanként – amíg Ön a weboldalunkat böngészi, vagy
    amikor később újból meglátogatja – a webszerver visszaolvassa onnan.
  </p>
  <p>
    A süti tartalmának segítségével képes a weboldal (szerver) a felhasználói
    élményt javítani, illetve a weboldalon nyújtott szolgáltatásokat
    megvalósítani. Amikor például egy webáruházban vásárol, általában ilyen
    sütik alkalmazásával képes a webáruház megkülönböztetni egymástól és kezelni
    a folyamatban lévő vásárlásokat (pl.: a kosár aktuális tartalmát). Ha
    vásárlás közben esetleg megszakad az internetkapcsolata, a weboldal a
    korábban letárolt süti alapján tudja azt, hogy milyen terméket tett be a
    kosarába, melyik terméket kereste, s amennyiben helyreállt a kapcsolat,
    folytatni tudja a vásárlást ott, ahol éppen abbahagyta.
  </p>
  <p><strong>Az adatkezelés célja </strong></p>
  <p>
    A weboldalunkra látogató felhasználók azonosítása, egymástól való
    megkülönböztetése, illetve a felhasználók aktuális munkamenetének
    azonosítása, az annak során megadott adatok tárolása, az adatvesztés
    megakadályozása.
  </p>
  <p><strong>A kezelt adatok köre </strong></p>
  <p>
    A weboldalunkon alkalmazott sütik a weboldal működését támogató, úgynevezett
    funkcionális sütik, amelyek a weboldal felkeresésének időpontját, a
    munkamenet azonosítót és a munkamenetre vonatkozó egyéb, a weboldal
    programkódja által értelmezhető információkat (szám- és karaktersorok)
    tartalmaznak.
  </p>
  <p>
    A funkcionális sütikben tárolt információkat nem továbbítjuk harmadik fél
    számára.
  </p>
  <p><strong>Az adatkezelés időtartama </strong></p>
  <p>
    A weboldalunkon alkalmazott egyik funkcionális süti érvényessége lejár,
    amint Ön a weboldalt elhagyja, illetve bezárja a böngésző programjában
    oldalunk. A másik funkcionális süti érvényességi ideje a weboldal által
    automatikusan generált módon 1 év elteltével jár le. Ugyanakkor ezen,
    hosszabb időre érvényes süti tartalmához weboldalunk kizárólag akkor férhet
    hozzá, ha Ön újra felkeresi weboldalunkat ugyanarról a készülékről és ezt a
    sütit időközben nem törölte le arról.
  </p>
  <p><strong>Jogérvényesítés </strong></p>
  <p>
    A legtöbb internet böngésző program automatikusan engedélyezi a sütik
    használatát. Ön viszont ezt a beállítást bármikor megváltoztathatja,
    tilthatja és törölheti is a sütiket. A készülékén tárolt sütik tartalmához
    bármikor hozzáférhet, azt megismerheti, megnézheti.
  </p>
  <p>
    A sütik kezelésére, használatuk letiltására vagy törlésére az ismert
    internet böngésző programoknak általában a beállításaik között, jellemzően a
    biztonság, adatvédelem vagy adatvédelmi beállítások elnevezésű almenüben,
    süti vagy cookie néven van lehetősége.
  </p>
  <p>
    További információkat a sütik kezeléséről az adott program súgójában,
    illetve a következő hivatkozásokon, a program nevére kattintva találhat:
    Internet Explorer, Chrome, Mozilla Firefox, Edge.
  </p>
  <p><strong>Kapcsolatfelvétel céljából kezelt adatok </strong></p>
  <p>
    Weboldalunkon megtalálható elérhetőségeink bármelyikén felveheti Velünk a
    kapcsolatot. A kapcsolatfelvétel során megadott személyes adatait kizárólag
    az Önnel való kapcsolattartásra használjuk, azokat nem továbbítjuk.
  </p>
  <p><strong>Az adatkezelés célja </strong></p>
  <p>Az ügyfelekkel történő kapcsolattartás.</p>
  <p><strong>&nbsp;</strong></p>
  <p><strong>Az adatkezelés jogalapja </strong></p>
  <p>
    Érdeklődés, tájékoztatás kérése, valamint bejelentés esetén önkéntes
    hozzájáruláson alapul az adatkezelés az EU általános adatvédelmi rendelete
    (GDPR) és az információs önrendelkezési jogról és információszabadságról
    szóló 2011. évi CXII. törvény (Infotörvény) alapján.
  </p>
  <p><strong>A kezelt adatok köre </strong></p>
  <p>
    A kapcsolattartásra az alábbi adatok közül az Ön által önkéntesen
    megadottakat kezeljük:
  </p>
  <p>. név,</p>
  <p>. email cím,</p>
  <p>. telefonszám,</p>
  <p>. cím (postacím).</p>
  <p><strong>Az adatkezelés időtartama </strong></p>
  <p>
    A kapcsolattartás céljából megadott személyes adatait a kapcsolatfelvétel
    jellegétől függően különböző ideig kezeljük.
  </p>
  <p>
    A szükséges tájékoztatás megadását követően nem őrizzük tovább, kivéve, ha
    az eseti jellegű kapcsolatfelvétel tárgyában jogszerűen igény
    érvényesíthető, abban az esetben annak igazolhatósága céljából legfeljebb 5
    évig megőrizhetjük.
  </p>
  <p><strong>Jogérvényesítés </strong></p>
  <p>
    Adatai kezeléséről bármikor kérhet tájékoztatást fenti elérhetőségeinken.
  </p>
  <p>
    Szintén bármikor kérheti adatai helyesbítését, amennyiben azt tapasztalja,
    hogy például hibásan adta meg vagy tévesen, illetve hiányosan rögzítettük
    azokat.
  </p>
  <p>
    Adatai törlését is kérheti, s ha annak nincs jogszabályi akadálya, akkor
    kérésének haladéktalanul eleget teszünk (ellenkező esetben pedig
    tájékoztatjuk a törlés megtagadásának indokáról).
  </p>
  <p><strong>Kik ismerhetik meg az adatokat? </strong></p>
  <p>
    Az Ön által megadott adatok megismerésére kizárólag munkatársaink
    jogosultak.
  </p>
  <p>Weboldalon megjelenített kép- és videó felvételek</p>
  <p>
    Weboldalunkon rendszeresen beszámolunk a településünket érintő
    rendezvényekről, eseményekről, programokról, amelyek kapcsán kép és
    videofelvételeket is megjelentetünk. Kiemelt figyelmet fordítunk arra, hogy
    a weboldalunkon megjelentetett kép- és videó felvételek tartalma ne
    sérthesse mások személyiségi jogait vagy jogos érdekeit, s azok jogszerű
    felhasználására engedéllyel, felhatalmazással rendelkezzünk minden esetben.
  </p>
  <p><strong>Az adatkezelés célja </strong></p>
  <p>A weboldal látogatóinak tájékoztatása.</p>
  <p><strong>&nbsp;</strong></p>
  <p><strong>&nbsp;</strong></p>
  <p><strong>Az adatkezelés jogalapja </strong></p>
  <p>
    Önkéntes hozzájáruláson alapul az adatkezelés az EU általános adatvédelmi
    rendelete (GDPR) és az információs önrendelkezési jogról és
    információszabadságról szóló 2011. évi CXII. törvény (Infotv.) alapján.
  </p>
  <p><strong>A kezelt adatok köre </strong></p>
  <p>
    A felvételeken szereplő, beazonosítható, felismerhető természetes személyek
    képmása.
  </p>
  <p><strong>Az adatkezelés időtartama</strong></p>
  <p>
    Az érintett hozzájárulása visszavonásáig, illetve az adott tartalom
    weboldalunkról történő törléséig.
  </p>
  <p><strong>Jogérvényesítés </strong></p>
  <p>
    Adatai kezeléséről bármikor kérhet tájékoztatást fenti elérhetőségeinken
    vagy az adott rendezvény, program szervezőjétől, amennyiben nem
    Önkormányzatunk szervezte azt.
  </p>
  <p>
    Adatai törlését is kérheti, s kérésére azokat a felvételeket, amelyeken
    beazonosítható, felismerhető, weboldalunkról eltávolítjuk.
  </p>
  <p><strong>Kik ismerhetik meg az adatokat? </strong></p>
  <p>
    A weboldalunkon nyilvánosságra hozott információkat bárki megismerheti,
    megtekintheti, aki meglátogatja az oldalt.
  </p>
  <p><strong>Az adatkezelés biztonsága </strong></p>
  <p>
    Az általunk kezelt személyes adatok biztonsága érekében megteszünk minden
    olyan technikai és szervezési intézkedést, amely szükséges ahhoz, hogy az
    adatok védettek legyenek a véletlen törlés (megsemmisülés), a jogosulatlan
    felhasználás vagy módosítás ellen. Az informatikai rendszereinkben kezelt
    adatokhoz a hozzáférést jogosultsági rendszer alkalmazásával, kizárólag
    munkatársaink számára engedélyezzük.
  </p>
  <p>
    Fentiekkel gondoskodunk arról, hogy a kezelt adatokhoz illetéktelen személy
    ne férhessen hozzá, ne hozhassa nyilvánosságra, ne továbbíthassa, valamint
    ne módosíthassa vagy törölhesse azokat.
  </p>
  <p><strong>Az adatok továbbítása </strong></p>
  <p>
    Személyes adatait azok megismerésére jogosultsággal nem rendelkezők számára
    nem adjuk át, harmadik félnek kizárólag abban az esetben továbbítjuk, ha Ön
    ehhez előzetesen hozzájárulását adta.
  </p>
  <p>
    Kivételt képezhet ez alól egy esetleges hatósági vizsgálat, amely esetén az
    eljáró hatóság (pl.: rendőrség, ügyészség, bíróság, stb.) hivatalos
    megkeresésére a megkeresés céljából szükséges adatokat kötelesek vagyunk
    átadni. Ehhez az Ön külön hozzájárulása nem szükséges, mivel ez törvényben
    meghatározott feladatunk.
  </p>
  <p>
    <strong
      >Az Adatkezelési tájékoztató felülvizsgálata és elérhetősége
    </strong>
  </p>
  <p>
    Fenntartjuk a jogot jelen tájékoztató felülvizsgálatára és szükség szerinti
    módosítására, amely indokolt lehet a vonatkozó jogszabályok vagy
    adatkezelési tevékenységünk, az arra alkalmazott technológia megváltozása
    esetén egyaránt. Amennyiben a módosítás az önkéntes hozzájárulása alapján
    kezelt személyes adatait is érinti, akkor erről haladéktalanul
    tájékoztatjuk, s személyes adatai további kezelését felfüggesztjük
    mindaddig, amíg ahhoz nem járul hozzá újra.
  </p>
  <p>
    A mindenkori hatályos Adatkezelési tájékoztató elérhető mindig itt, a
    weboldalon nyilvánosan közzé téve.
  </p>
</div>
